import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

export default class ConfigSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            terminalName: localStorage['config_terminal_name'] || 'Sunucu',
            departmentName: localStorage['config_department_name'] || 'Restoran',
            ticketTypeName: localStorage['config_ticket_type_name'] || 'Restoran',
            menuName: localStorage['config_menu_name'] || 'Menuler',
            entityScreenName: localStorage['config_entity_screen_name'] || 'Tüm Masalar',
            clientEntityName: localStorage['config_client_entity_name'] || 'Müşteriler',
            message: ''
        };
    }

    save = () => {
        localStorage['config_terminal_name'] = (this.state.terminalName || '').trim() || 'Sunucu';
        localStorage['config_department_name'] = (this.state.departmentName || '').trim() || 'Restoran';
        localStorage['config_ticket_type_name'] = (this.state.ticketTypeName || '').trim() || 'Restoran';
        localStorage['config_menu_name'] = (this.state.menuName || '').trim() || 'Menuler';
        localStorage['config_entity_screen_name'] = (this.state.entityScreenName || '').trim() || 'Tüm Masalar';
        localStorage['config_client_entity_name'] = (this.state.clientEntityName || '').trim() || 'Müşteriler';

        this.setState({ message: 'Konfigurasyon kaydedildi.' });
    }

    clear = () => {
        localStorage.removeItem('config_terminal_name');
        localStorage.removeItem('config_department_name');
        localStorage.removeItem('config_ticket_type_name');
        localStorage.removeItem('config_menu_name');
        localStorage.removeItem('config_entity_screen_name');
        localStorage.removeItem('config_client_entity_name');

        this.setState({
            terminalName: 'Sunucu',
            departmentName: 'Restoran',
            ticketTypeName: 'Restoran',
            menuName: 'Menuler',
            entityScreenName: 'Tüm Masalar',
            clientEntityName: 'Müşteriler',
            message: 'Varsayılan ayarlara dönüldü.'
        });
    }

    goBack = () => {
        this.context.router.push('/login');
    }

    render() {
        return (
            <div style={{ padding: '20px' }}>
                <h3>Konfigurasyon Ayarları</h3>

                <TextField
                    floatingLabelText="Terminal Name"
                    value={this.state.terminalName}
                    onChange={(e) => this.setState({ terminalName: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Department Name"
                    value={this.state.departmentName}
                    onChange={(e) => this.setState({ departmentName: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Ticket Type Name"
                    value={this.state.ticketTypeName}
                    onChange={(e) => this.setState({ ticketTypeName: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Menu Name"
                    value={this.state.menuName}
                    onChange={(e) => this.setState({ menuName: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Entity Screen Name"
                    value={this.state.entityScreenName}
                    onChange={(e) => this.setState({ entityScreenName: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Client Entity Name"
                    value={this.state.clientEntityName}
                    onChange={(e) => this.setState({ clientEntityName: e.target.value })}
                    fullWidth={true}
                />

                <br />
                <br />

                <RaisedButton label="Kaydet" primary={true} onClick={this.save} />
                {' '}
                <RaisedButton label="Tümünü Temizle" onClick={this.clear} />
                {' '}
                <RaisedButton label="Geri" onClick={this.goBack} />

                <br />
                <br />

                <div>{this.state.message}</div>
            </div>
        );
    }
}

ConfigSettings.contextTypes = {
    router: React.PropTypes.object
};


// WEBPACK FOOTER //
// ./app/components/ConfigSettings.jsx